/* eslint-disable camelcase */
import {
    UPDATE_EQUITY_DETAILS_SUCCESS,
    UPDATE_EQUITY_DETAILS_FAILURE,
} from '../actions';
import {
    SET_EQUITY_CU_IN_PROGRESS,
    SET_EQUITY_ORDER_SUBMITTED,
} from '../actions/actionTypes';

import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { removeEmptyFieldsFromObject } from 'src/utils/util';

export default function* updateEquity(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/order/equity`;
    const isSubmitted = action.payload.isSubmittedFromSurgeryFlow;
    delete action.payload.isSubmittedFromSurgeryFlow;
    const payload = removeEmptyFieldsFromObject(action.payload);
    const isEquityOrderSubmitted = action.payload.isSAPSubmission;

    try {
        const result = yield axios
            .put(url, payload)
            .then((response) => response.data);

        const modify_result = {
            ...result,
            isSubmitted,
        };
        yield put({
            type: UPDATE_EQUITY_DETAILS_SUCCESS,
            data: modify_result,
        });
        yield put({
            type: SET_EQUITY_ORDER_SUBMITTED,
            data: isEquityOrderSubmitted,
        });
        yield put({ type: SET_EQUITY_CU_IN_PROGRESS, data: false });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: payload
        });
        yield put({
            type: UPDATE_EQUITY_DETAILS_FAILURE,
            data: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
